var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRatingActive = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 8 8",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 6 2.008 7.047a.2.2 0 0 1-.29-.21l.38-2.219L.486 3.047a.2.2 0 0 1 .11-.341l2.228-.324.997-2.019a.2.2 0 0 1 .358 0l.997 2.019 2.227.324a.2.2 0 0 1 .111.34L5.902 4.619l.38 2.219a.2.2 0 0 1-.29.21L4 6Z",
  fill: "#87888B",
  fillRule: "evenodd"
})));
export default SvgRatingActive;